// src/entities/account/status.tsx
import { UserStatusEnum } from "@acme/api/client";
import { Alert } from "flowbite-react";
import { jsx, jsxs } from "react/jsx-runtime";
var formatDate = (dateString) => {
  if (!dateString)
    return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  });
};
var formatDateTime = (dateString) => {
  if (!dateString)
    return "";
  const date = new Date(dateString);
  const dateStr = formatDate(dateString);
  const timeStr = date.toLocaleTimeString("ru-RU", {
    hour: "2-digit",
    minute: "2-digit"
  });
  return `${dateStr}, ${timeStr}`;
};
var checkIcon = /* @__PURE__ */ jsx(
  "svg",
  {
    className: "w-4 h-4",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24",
    children: /* @__PURE__ */ jsx(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
      }
    )
  }
);
var AccountStatusAlert = ({
  status,
  date: currentStatusStartAt
}) => {
  if (status === UserStatusEnum.Confirmed) {
    return /* @__PURE__ */ jsx(
      Alert,
      {
        color: "success",
        className: "bg-green-50 rounded-[6px] px-4 py-2 border-0",
        children: /* @__PURE__ */ jsxs("span", { className: "text-sm font-normal text-green-800", children: [
          "\u0423\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D\u0430:",
          " ",
          currentStatusStartAt ? formatDateTime(currentStatusStartAt) : ""
        ] })
      }
    );
  }
  if (status === UserStatusEnum.ExpectsChanges) {
    return /* @__PURE__ */ jsx(
      Alert,
      {
        color: "failure",
        className: "bg-red-50 rounded-[6px] px-4 py-2 border-0",
        children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex gap-2 items-center", children: [
            checkIcon,
            /* @__PURE__ */ jsx("span", { className: "text-base font-semibold text-red-800", children: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C \u043D\u0435 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D" })
          ] }),
          /* @__PURE__ */ jsx("p", { className: "text-sm font-normal text-red-800", children: "\u041D\u0443\u0436\u043D\u043E \u043F\u043E\u043C\u0435\u043D\u044F\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435" })
        ] })
      }
    );
  }
  if (status === UserStatusEnum.Blocked) {
    return /* @__PURE__ */ jsx(
      Alert,
      {
        color: "failure",
        className: "bg-red-50 rounded-[6px] px-4 py-2 border-0",
        children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex gap-2 items-center", children: [
            checkIcon,
            /* @__PURE__ */ jsx("span", { className: "text-base font-semibold text-red-800", children: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C \u043D\u0435 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D" })
          ] }),
          /* @__PURE__ */ jsx("p", { className: "text-sm font-normal text-red-800", children: "\u041D\u0443\u0436\u043D\u043E \u043F\u043E\u043C\u0435\u043D\u044F\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435 \u0432 \u043F\u043E\u043B\u0435 \xAB\u041E\u0413\u0420\u041D\xBB, \xAB\u041A\u043E\u0440\u0440. \u0441\u0447\u0451\u0442\xBB, \xAB\u0421\u041D\u0418\u041B\u0421\xBB" })
        ] })
      }
    );
  }
  if (status === UserStatusEnum.Awaiting\u0421onfirmation) {
    return /* @__PURE__ */ jsx(
      Alert,
      {
        color: "warning",
        className: "bg-orange-50 rounded-[6px] px-4 py-2 border-0",
        children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex gap-2 items-center", children: [
            checkIcon,
            /* @__PURE__ */ jsx("span", { className: "text-base font-semibold text-orange-800", children: "\u0414\u0430\u043D\u043D\u044B\u0435 \u043D\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0435" })
          ] }),
          /* @__PURE__ */ jsx("p", { className: "text-sm font-normal text-orange-800", children: currentStatusStartAt ? `\u0414\u0430\u043D\u043D\u044B\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B \u043D\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443 ${formatDate(
            currentStatusStartAt
          )}` : "\u0414\u0430\u043D\u043D\u044B\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B \u043D\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443. \u041E\u0436\u0438\u0434\u0430\u0439\u0442\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F." })
        ] })
      }
    );
  }
  return null;
};

// src/entities/application/lib/applicationAddContractFormConfig.ts
var addContractFormConfig = (includeUnchangedFields = true) => ({
  id: "add-contract-form",
  includeUnchangedFields,
  // возвращаем все поля или только измененные
  controls: [
    {
      id: "contractUniqueNumber",
      label: "\u0423\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430",
      type: "text",
      read: (ctx) => ctx?.contractUniqueNumber || "",
      write: { path: "contractUniqueNumber" },
      props: {
        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430"
      }
    },
    {
      id: "tradeAgreementNumber",
      label: "\u041D\u043E\u043C\u0435\u0440 \u0432\u043D\u0435\u0448\u043D\u0435\u0442\u043E\u0440\u0433\u043E\u0432\u043E\u0433\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430",
      type: "text",
      read: (ctx) => ctx?.tradeAgreementNumber || "",
      write: { path: "tradeAgreementNumber" },
      props: {
        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u0432\u043D\u0435\u0448\u043D\u0435\u0442\u043E\u0440\u0433\u043E\u0432\u043E\u0433\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430"
      }
    }
  ]
});

// src/entities/application/lib/applicationOfferFormConfig.ts
var applicationOfferFormMainInfoConfig = (includeUnchangedFields = true, options) => ({
  id: "create-application-form",
  includeUnchangedFields,
  // возвращаем все поля или только измененные
  controls: [
    {
      id: "commissionAuthorizedOrganizationRUB",
      label: "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F \u0443\u043F\u043E\u043B\u043D\u043E\u043C\u043E\u0447\u0435\u043D\u043D\u043E\u0439 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438, \u0440\u0443\u0431",
      type: "number",
      read: (ctx) => ctx?.commissionAuthorizedOrganizationRUB || "",
      write: { path: "commissionAuthorizedOrganizationRUB" }
    },
    {
      id: "commissionAgentRUB",
      label: "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F \u0430\u0433\u0435\u043D\u0442\u0430, \u0440\u0443\u0431",
      type: "number",
      read: (ctx) => ctx?.commissionAgentRUB || "",
      write: { path: "commissionAgentRUB" },
      props: {
        placeholder: "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0438\u043B\u0438 \u0432\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043A\u043E\u043D\u0442\u0440\u0430\u0433\u0435\u043D\u0442\u0430"
      }
    },
    {
      id: "agentCryptoAddress",
      label: "\u041A\u0440\u0438\u043F\u0442\u043E\u0430\u0434\u0440\u0435\u0441 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0430\u0433\u0435\u043D\u0442\u0430",
      type: "text",
      read: (ctx) => ctx?.agentCryptoAddress || "",
      write: { path: "agentCryptoAddress" },
      props: {
        placeholder: "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0438\u043B\u0438 \u0432\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043A\u0440\u0438\u043F\u0442\u043E\u0430\u0434\u0440\u0435\u0441"
      }
    },
    {
      id: "agentWalletNetId",
      label: "\u0421\u0435\u0442\u044C",
      type: "select",
      read: (ctx) => ctx?.agentWalletNetId || "",
      write: { path: "agentWalletNetId" },
      props: {
        placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0435\u0442\u044C"
      },
      options: {
        source: options.nets
      }
    },
    {
      id: "cryptoCurrencyId",
      label: "\u041A\u0440\u0438\u043F\u0442\u043E\u0432\u0430\u043B\u044E\u0442\u0430",
      type: "select",
      read: (ctx) => ctx?.cryptoCurrencyId || "",
      write: { path: "cryptoCurrencyId" },
      props: {
        placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u0440\u0438\u043F\u0442\u043E\u0432\u0430\u043B\u044E\u0442\u0443"
      },
      options: {
        source: options.cryptoCurrencies
      }
    },
    {
      id: "cryptoAmount",
      label: "\u0421\u0443\u043C\u043C\u0430 \u043A\u0440\u0438\u043F\u0442\u043E\u0432\u0430\u043B\u044E\u0442\u044B",
      type: "text",
      read: (ctx) => ctx?.cryptoAmount || "",
      write: { path: "cryptoAmount" }
    }
  ]
});
var applicationOfferFormAddInfoConfig = (includeUnchangedFields = true, options) => ({
  id: "create-application-form",
  includeUnchangedFields,
  // возвращаем все поля или только измененные
  controls: [
    {
      id: "organizationName",
      label: "\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438",
      type: "text",
      read: (ctx) => ctx?.organizationName || "",
      write: { path: "organizationName" },
      props: {
        placeholder: "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0438\u043B\u0438 \u0432\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435"
      }
    },
    {
      id: "senderCountryId",
      label: "\u0421\u0442\u0440\u0430\u043D\u0430 \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B\u044F",
      type: "select",
      read: (ctx) => ctx?.senderCountryId || "",
      write: { path: "senderCountryId" },
      props: {
        placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0443"
      },
      options: {
        source: options.countries
      }
    },
    {
      id: "bankName",
      label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430",
      type: "text",
      read: (ctx) => ctx?.bankName || "",
      write: { path: "bankName" },
      props: {
        placeholder: "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0438\u043B\u0438 \u0432\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430"
      }
    }
  ]
});

// src/entities/application/lib/createApplicationFormPaymentConfig.tsx
var createApplicationFormPaymentConfig = (includeUnchangedFields = true, dictionariesOptions, isCryptoPayment) => {
  return {
    id: "create-application-payment-form",
    includeUnchangedFields,
    // возвращаем все поля или только измененные
    controls: [
      ...isCryptoPayment ? [
        {
          id: "walletAddress",
          label: "\u0410\u0434\u0440\u0435\u0441 \u043A\u0440\u0438\u043F\u0442\u043E\u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430",
          type: "text",
          read: (ctx) => ctx?.walletAddress || "",
          write: { path: "walletAddress" },
          props: {
            placeholder: "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0438\u043B\u0438 \u0432\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0430\u0434\u0440\u0435\u0441 \u043A\u0440\u0438\u043F\u0442\u043E\u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430"
          }
        },
        {
          id: "cryptoAmount",
          label: "\u0421\u0443\u043C\u043C\u0430 \u043A\u0440\u0438\u043F\u0442\u043E\u0432\u0430\u043B\u044E\u0442\u044B",
          type: "number",
          read: (ctx) => ctx?.cryptoAmount || "",
          write: { path: "cryptoAmount" },
          props: {
            placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0443\u043C\u043C\u0443"
          }
        },
        {
          id: "cryptocurrency",
          label: "\u041A\u0440\u0438\u043F\u0442\u043E\u0432\u0430\u043B\u044E\u0442\u0430",
          type: "select",
          read: (ctx) => ctx?.cryptocurrency || "",
          write: { path: "cryptocurrency" },
          props: {
            placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u0440\u0438\u043F\u0442\u043E\u0432\u0430\u043B\u044E\u0442\u0443"
          },
          options: {
            source: dictionariesOptions.cryptoCurrencyOptions
          }
        }
      ] : [
        {
          id: "countryId",
          label: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0443",
          type: "select",
          read: (ctx) => ctx?.countryId || "",
          write: { path: "countryId" },
          props: {
            placeholder: "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0432\u0430\u043B\u044E\u0442\u0443 \u043F\u0435\u0440\u0435\u0432\u043E\u0434\u0430"
          },
          options: {
            source: dictionariesOptions.countryOptions
          }
        },
        {
          id: "bankName",
          label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430",
          type: "text",
          read: (ctx) => ctx?.bankName || "",
          write: { path: "bankName" },
          props: {
            placeholder: "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0438\u043B\u0438 \u0432\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430"
          }
        },
        {
          id: "bankAddress",
          label: "\u0410\u0434\u0440\u0435\u0441 \u0431\u0430\u043D\u043A\u0430",
          type: "text",
          read: (ctx) => ctx?.bankAddress || "",
          write: { path: "bankAddress" },
          props: {
            placeholder: "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0438\u043B\u0438 \u0432\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0430\u0434\u0440\u0435\u0441 \u0431\u0430\u043D\u043A\u0430",
            className: "col-span-2"
          }
        },
        {
          id: "iBAN",
          label: "IBAN",
          type: "text",
          read: (ctx) => ctx?.iBAN || "",
          write: { path: "iBAN" },
          props: {
            placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0438\u043B\u0438 \u0432\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043D\u043E\u043C\u0435\u0440"
          }
        },
        {
          id: "sWIFT_BIC",
          label: "SWIFT/BIC",
          type: "text",
          read: (ctx) => ctx?.sWIFT_BIC || "",
          write: { path: "sWIFT_BIC" },
          props: {
            placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0438\u043B\u0438 \u0432\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043A\u043E\u0434"
          }
        }
      ]
    ]
  };
};

// src/entities/application/lib/createapplicationwalletaddressesformconfig.ts
var createapplicationwalletaddressesformconfig = (includeUnchangedFields = true, wallets, withLabel = false) => {
  const controls = Array.from({
    length: wallets
  }).map((_, idx) => ({
    id: `wallet-${idx}`,
    type: "text",
    ...withLabel && idx === 0 ? { label: "\u0410\u0434\u0440\u0435\u0441 \u043A\u0440\u0438\u043F\u0442\u043E\u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430" } : {},
    read: (ctx) => String(ctx?.[`wallet-${idx}`] ?? ""),
    write: { path: `wallet-${idx}` },
    props: {
      placeholder: "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0438\u043B\u0438 \u0432\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0430\u0434\u0440\u0435\u0441 \u0441 \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u043F\u043B\u0430\u043D\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u043F\u0435\u0440\u0435\u0432\u043E\u0434",
      className: "col-span-2"
    }
  }));
  return {
    id: "application-wallet-addresses-form",
    includeUnchangedFields,
    controls
  };
};

// src/entities/application/lib/sendOfferFormConfig.ts
var requiredAlways = {
  when: () => true,
  set: { required: true }
};
var sendOfferFormConfig = () => ({
  id: "send-offer-form",
  includeUnchangedFields: false,
  controls: [
    {
      id: "contractUniqueNumber",
      label: "\u0423\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430",
      type: "text",
      read: (ctx) => ctx?.contractUniqueNumber ?? "",
      write: { path: "contractUniqueNumber" },
      validation: (v) => typeof v === "string" && !v.trim() ? "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435" : null,
      props: { placeholder: "123456789012" },
      rules: [requiredAlways]
    },
    {
      id: "tradeAgreementNumber",
      label: "\u041D\u043E\u043C\u0435\u0440 \u0432\u043D\u0435\u0448\u043D\u0435\u0442\u043E\u0440\u0433\u043E\u0432\u043E\u0433\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430",
      type: "text",
      read: (ctx) => ctx?.tradeAgreementNumber ?? "",
      write: { path: "tradeAgreementNumber" },
      validation: (v) => typeof v === "string" && !v.trim() ? "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435" : null,
      props: { placeholder: "123456789012" },
      rules: [requiredAlways]
    },
    {
      id: "files",
      label: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432",
      type: "fileUpload",
      read: () => [],
      write: {
        path: "files",
        transform: (v) => Array.isArray(v) ? v.map((u) => u.file) : []
      },
      props: {
        label: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432",
        accept: ".pdf",
        maxSize: 10,
        multiple: true,
        showInfoIcon: true
      }
    }
  ]
});

// src/entities/auth/lib/hooks.ts
import { useState } from "react";
var useAuth = ({
  authService,
  login,
  onSuccessRedirect,
  onErrorRedirect
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [
    remainingCountOfPasswordAttempts,
    setRemainingCountOfPasswordAttempts
  ] = useState(null);
  const auth = async (selectedCertificate, secret, password, role) => {
    setLoading(true);
    setError(null);
    try {
      const resp = await authService.getAuthToken(
        selectedCertificate,
        secret.secret,
        role,
        password
      );
      if (!resp.isSuccess) {
        const errorMessage = resp.errorText || "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 \u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438";
        setError(errorMessage);
        setRemainingCountOfPasswordAttempts(null);
        if (onErrorRedirect) {
          onErrorRedirect(errorMessage);
        }
        return;
      }
      if (!resp.data) {
        const errorMessage = resp.errorText || "\u0421\u0435\u0440\u0432\u0435\u0440 \u0432\u0435\u0440\u043D\u0443\u043B \u043F\u0443\u0441\u0442\u043E\u0439 \u043E\u0442\u0432\u0435\u0442";
        setError(errorMessage);
        setRemainingCountOfPasswordAttempts(null);
        if (onErrorRedirect) {
          onErrorRedirect(errorMessage);
        }
        return;
      }
      const tokenResponse = resp.data;
      if (!tokenResponse.isSuccess) {
        const remainingAttempts = tokenResponse.remainingCountOfPasswordAttempts ?? null;
        if (remainingAttempts === 0 || remainingAttempts === null) {
          const errorMessage = "\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D \u043B\u0438\u043C\u0438\u0442 \u043E\u0448\u0438\u0431\u043E\u043A";
          setError(errorMessage);
          setRemainingCountOfPasswordAttempts(null);
          if (onErrorRedirect) {
            onErrorRedirect(errorMessage);
          }
          return;
        }
        setError("\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C");
        setRemainingCountOfPasswordAttempts(remainingAttempts);
        return;
      }
      if (!tokenResponse.accessToken) {
        const errorMessage = resp.errorText || "\u0422\u043E\u043A\u0435\u043D \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043D\u0435 \u0431\u044B\u043B \u043F\u043E\u043B\u0443\u0447\u0435\u043D";
        setError(errorMessage);
        setRemainingCountOfPasswordAttempts(null);
        if (onErrorRedirect) {
          onErrorRedirect(errorMessage);
        }
        return;
      }
      setRemainingCountOfPasswordAttempts(null);
      login(tokenResponse);
      if (onSuccessRedirect) {
        onSuccessRedirect(tokenResponse.userStatus);
      }
    } catch (e) {
      const errorMessage = e instanceof Error ? e.message : "\u041D\u0435\u043E\u0436\u0438\u0434\u0430\u043D\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438";
      setError(errorMessage);
      setRemainingCountOfPasswordAttempts(null);
      if (onErrorRedirect) {
        onErrorRedirect(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };
  return { auth, loading, error, remainingCountOfPasswordAttempts };
};

// src/entities/certificate/hooks.ts
import { getUserCertificates } from "crypto-pro";
import { useEffect, useState as useState2 } from "react";

// src/entities/certificate/lib.ts
import { AuthorizeService as AdminAuthorizeService } from "@acme/api/admin";
import {
  AuthorizeService as ClientAuthorizeService
} from "@acme/api/client";
import { createAttachedSignature } from "crypto-pro";
var getAuthSecret = async (cert) => {
  const response = await ClientAuthorizeService.postApiV1AuthorizeSecret({
    requestBody: { certificateBase64: await cert.exportBase64() }
  });
  if (!response.isSuccess || !response.data || !response.data.secret) {
    throw new Error(response.errorText || "Auth secret error");
  }
  return response.data;
};
var getAuthToken = async (cert, secret, role, password) => {
  const sign = await createAttachedSignature(cert.thumbprint, secret);
  const tokenResponse = await ClientAuthorizeService.postApiV1AuthorizeToken({
    requestBody: {
      attachedSignatureBase64: sign,
      roleId: role,
      password
    }
  });
  return tokenResponse;
};
var getAuthSecretAdmin = async (cert) => {
  const response = await AdminAuthorizeService.postApiAdminV1AuthorizeSecret({
    requestBody: { certificateBase64: await cert.exportBase64() }
  });
  if (!response.isSuccess || !response.data || !response.data.secret) {
    throw new Error(response.errorText || "Auth secret error");
  }
  return response.data;
};
var getAuthTokenAdmin = async (cert, secret, role, password) => {
  const sign = await createAttachedSignature(cert.thumbprint, secret);
  const tokenResponse = await AdminAuthorizeService.postApiAdminV1AuthorizeToken({
    requestBody: {
      attachedSignatureBase64: sign,
      roleId: role,
      password
    }
  });
  return tokenResponse;
};

// src/entities/certificate/hooks.ts
var useCertificates = (callback) => {
  const [certificates, setCertificates] = useState2([]);
  const [certificatesError, setCertificatesError] = useState2(null);
  const [certificate, setCertificate] = useState2(
    void 0
  );
  const [loading, setLoading] = useState2(false);
  useEffect(() => {
    (async () => {
      try {
        setCertificates(await getUserCertificates());
      } catch (error) {
        setCertificatesError(error);
      }
    })();
  }, []);
  const selectCertificate = async (thumbprint) => {
    setLoading(true);
    const selectedCertificate = certificates.find(
      ({ thumbprint: certThumbprint }) => certThumbprint === thumbprint
    );
    setCertificate(selectedCertificate);
    if (selectedCertificate) {
      try {
        const secretData = await getAuthSecret(selectedCertificate);
        if (callback) {
          callback(selectedCertificate, secretData);
        }
      } catch (error) {
        console.error("Error:", error);
        setLoading(false);
        setCertificatesError(error);
      }
    }
  };
  const validCurrentCertificate = (user) => {
    const result = {};
    return certificates.find((c) => {
      const regex = /([\wА-ЯЁ\s]+)=([^,]+)/g;
      for (const [, key, value] of c.subjectName.matchAll(regex)) {
        result[key.trim()] = value;
      }
      return result?.E === user?.person?.email;
    });
  };
  return {
    certificates,
    certificatesError,
    certificate,
    loading,
    selectCertificate,
    validCurrentCertificate
  };
};

// src/entities/country/hooks.ts
import { useEffect as useEffect2, useState as useState3 } from "react";

// src/entities/country/model.ts
import {
  DictionariesService
} from "@acme/api";
var CountryStore = class {
  countries = null;
  loadingPromise = null;
  error = null;
  async getCountries() {
    if (this.countries) {
      return this.countries;
    }
    if (this.loadingPromise) {
      return this.loadingPromise;
    }
    this.loadingPromise = (async () => {
      try {
        const response = await DictionariesService.getApiV1DictionariesCountries();
        if (!response.data) {
          throw new Error("No data received from countries API");
        }
        this.countries = response.data;
        return this.countries;
      } catch (err) {
        this.error = err instanceof Error ? err : new Error("Failed to load countries");
        throw this.error;
      } finally {
        this.loadingPromise = null;
      }
    })();
    return this.loadingPromise;
  }
  getCountryById(id) {
    return this.countries?.find((country) => country.id === id);
  }
  getCountryByCode(code) {
    return this.countries?.find((country) => country.name === code);
  }
};
var countryStore = new CountryStore();

// src/entities/country/hooks.ts
var useCountry = (countryId) => {
  const [country, setCountry] = useState3();
  const [countries, setCountries] = useState3([]);
  const [isLoading, setIsLoading] = useState3(true);
  const [error, setError] = useState3(null);
  useEffect2(() => {
    const loadCountry = async () => {
      try {
        setIsLoading(true);
        const countries2 = await countryStore.getCountries();
        setCountries(countries2);
        if (countryId) {
          const foundCountry = countries2.find(
            (c) => c.id === Number(countryId)
          );
          setCountry(foundCountry);
        }
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error("Failed to load country")
        );
      } finally {
        setIsLoading(false);
      }
    };
    loadCountry();
  }, [countryId]);
  return { country, countries, isLoading, error };
};

// src/entities/currency/hooks.ts
import { useEffect as useEffect3, useState as useState4 } from "react";

// src/entities/currency/model.ts
import {
  DictionariesService as DictionariesService2
} from "@acme/api";
var CurrencyStore = class {
  currencies = null;
  cryptoCurrencies = null;
  loadingPromise = null;
  cryptoLoadingPromise = null;
  error = null;
  async getCurrencies() {
    if (this.currencies) {
      return this.currencies;
    }
    if (this.loadingPromise) {
      return this.loadingPromise;
    }
    this.loadingPromise = (async () => {
      try {
        const response = await DictionariesService2.getApiV1DictionariesCurrencies();
        if (!response.data) {
          throw new Error("No data received from currencies API");
        }
        this.currencies = response.data;
        return this.currencies;
      } catch (err) {
        this.error = err instanceof Error ? err : new Error("Failed to load currencies");
        throw this.error;
      } finally {
        this.loadingPromise = null;
      }
    })();
    return this.loadingPromise;
  }
  getCurrencyById(id) {
    return this.currencies?.find((currency) => currency.id === id);
  }
  getCurrencyByCode(code) {
    return this.currencies?.find((currency) => currency.name === code);
  }
  async getCryptoCurrencies() {
    if (this.cryptoCurrencies) {
      return this.cryptoCurrencies;
    }
    if (this.cryptoLoadingPromise) {
      return this.cryptoLoadingPromise;
    }
    this.cryptoLoadingPromise = (async () => {
      try {
        const response = await DictionariesService2.getApiV1DictionariesCryptoCurrencies();
        if (!response.data) {
          throw new Error("No data received from crypto currencies API");
        }
        this.cryptoCurrencies = response.data;
        return this.cryptoCurrencies;
      } catch (err) {
        this.error = err instanceof Error ? err : new Error("Failed to load currencies");
        throw this.error;
      } finally {
        this.cryptoLoadingPromise = null;
      }
    })();
    return this.cryptoLoadingPromise;
  }
  getCryptoCurrencyById(id) {
    return this.cryptoCurrencies?.find((currency) => currency.id === id);
  }
  getCryptoCurrencyByCode(code) {
    return this.cryptoCurrencies?.find((currency) => currency.name === code);
  }
};
var currencyStore = new CurrencyStore();

// src/entities/currency/hooks.ts
var useCurrency = (currencyId) => {
  const [currency, setCurrency] = useState4();
  const [currencies, setCurrencies] = useState4([]);
  const [isLoading, setIsLoading] = useState4(true);
  const [error, setError] = useState4(null);
  useEffect3(() => {
    const loadCurrency = async () => {
      try {
        setIsLoading(true);
        const currencies2 = await currencyStore.getCurrencies();
        setCurrencies(currencies2);
        if (currencyId) {
          const foundCurrency = currencies2.find(
            (c) => c.id === Number(currencyId)
          );
          setCurrency(foundCurrency);
        }
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error("Failed to load currency")
        );
      } finally {
        setIsLoading(false);
      }
    };
    loadCurrency();
  }, [currencyId]);
  return { currency, currencies, isLoading, error };
};
var useCryptoCurrency = (currencyId) => {
  const [currency, setCurrency] = useState4();
  const [currencies, setCurrencies] = useState4([]);
  const [isLoading, setIsLoading] = useState4(true);
  const [error, setError] = useState4(null);
  useEffect3(() => {
    const loadCurrency = async () => {
      try {
        setIsLoading(true);
        const currencies2 = await currencyStore.getCryptoCurrencies();
        setCurrencies(currencies2);
        if (currencyId) {
          const foundCurrency = currencies2.find(
            (c) => c.id === Number(currencyId)
          );
          setCurrency(foundCurrency);
        }
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error("Failed to load currency")
        );
      } finally {
        setIsLoading(false);
      }
    };
    loadCurrency();
  }, [currencyId]);
  return { currency, currencies, isLoading, error };
};

// src/entities/currency/lib/toCurrency.ts
var toCurrency = (currency) => {
  if (!currency)
    return null;
  const name = currency.name ?? "";
  const fromStore = currency?.id != null ? currencyStore.getCurrencyById(currency.id) : void 0;
  const symbol = fromStore?.code ?? (currency && "code" in currency ? currency.code : null) ?? "";
  return {
    name,
    symbol: (symbol ?? "").trim() || ""
  };
};

// src/entities/currency/lib/currencyFormConfig.ts
var currencyFormConfig = (includeUnchangedFields = true, currencyTypeOptions) => ({
  id: "add-currency-form",
  includeUnchangedFields,
  controls: [
    {
      id: "code",
      label: "\u0421\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u0432\u0430\u043B\u044E\u0442\u044B",
      type: "text",
      read: (ctx) => ctx?.code || "",
      write: { path: "code" },
      props: {
        placeholder: "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0441\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435"
      }
    },
    {
      id: "type",
      label: "\u0422\u0438\u043F \u0432\u0430\u043B\u044E\u0442\u044B",
      type: "select",
      read: (ctx) => ctx?.type || "",
      write: { path: "type" },
      props: {
        placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u0432\u0430\u043B\u044E\u0442\u044B"
      },
      options: {
        source: currencyTypeOptions
      }
    },
    {
      id: "name",
      label: "\u041F\u043E\u043B\u043D\u043E\u0435 \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u0432\u0430\u043B\u044E\u0442\u044B",
      type: "textarea",
      read: (ctx) => ctx?.name || "",
      write: { path: "name" },
      props: {
        placeholder: "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u043F\u043E\u043B\u043D\u043E\u0435 \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435"
      }
    }
  ]
});

// src/entities/currency/types.ts
import {
  CurrencyTypeEnum as CurrencyTypeEnum2
} from "@acme/api";
var ECurrencyTypeEnum = { ...CurrencyTypeEnum2 };

// src/entities/error/lib/errorHandler.ts
var ErrorHandler = class {
  routes;
  navigate;
  onErrorCallback;
  constructor(config) {
    this.routes = config.routes;
    this.navigate = config.navigate;
    this.onErrorCallback = config.onError;
  }
  handle(error) {
    const statusCode = error.status;
    const route = this.routes?.[statusCode];
    if (this.onErrorCallback) {
      this.onErrorCallback(statusCode, error);
    }
    if (route && this.navigate) {
      this.navigate(route, { replace: true });
    } else if (route && !this.navigate) {
      window.location.href = route;
    }
  }
  setRoutes(routes) {
    this.routes = routes;
  }
  setNavigate(navigate) {
    this.navigate = navigate;
  }
  setOnError(callback) {
    this.onErrorCallback = callback;
  }
};

// src/entities/exchangeRate/hooks.ts
import { useCallback, useState as useState5 } from "react";

// src/entities/exchangeRate/model/exchangeRateStore.ts
import {
  ExchanegeRateService
} from "@acme/api";
var ExchangeRateStore = class {
  exchangeRates = null;
  loadingPromise = null;
  recommendedExchangeRates = null;
  recommendedLoadingPromise = null;
  error = null;
  async getExchangeRates(filter) {
    this.loadingPromise = (async () => {
      try {
        const response = await ExchanegeRateService.getApiV1ExchanegeRateList(filter);
        if (!response.data) {
          throw new Error("No data received from exchange rates API");
        }
        this.exchangeRates = response.data;
        return this.exchangeRates;
      } catch (err) {
        this.error = err instanceof Error ? err : new Error("Failed to load exchange rates");
        throw this.error;
      } finally {
        this.loadingPromise = null;
      }
    })();
    return this.loadingPromise;
  }
  async getRecommendedExchangeRates(filter) {
    if (this.recommendedExchangeRates) {
      return this.recommendedExchangeRates;
    }
    if (this.recommendedLoadingPromise) {
      return this.recommendedLoadingPromise;
    }
    this.recommendedLoadingPromise = (async () => {
      try {
        const response = await ExchanegeRateService.getApiV1ExchanegeRateRecommended(filter);
        if (!response.data) {
          throw new Error("No data received from exchange rates API");
        }
        this.recommendedExchangeRates = response.data;
        return this.recommendedExchangeRates;
      } catch (err) {
        this.error = err instanceof Error ? err : new Error("Failed to load recommended exchange rates");
        throw this.error;
      } finally {
        this.recommendedLoadingPromise = null;
      }
    })();
    return this.recommendedLoadingPromise;
  }
};
var exchangeRateStore = new ExchangeRateStore();

// src/entities/exchangeRate/model/recommendedRateStore.ts
import {
  ExchanegeRateService as ExchanegeRateService2
} from "@acme/api";
function getCacheKey(params) {
  return JSON.stringify({
    cryptoCurrencies: params.cryptoCurrencies ?? [],
    currencies: params.currencies ?? [],
    pageNumber: params.pageNumber,
    pageSize: params.pageSize
  });
}
var RecommendedRateStore = class {
  cache = /* @__PURE__ */ new Map();
  loadingPromises = /* @__PURE__ */ new Map();
  error = null;
  async getRecommendedRates(params = {}) {
    const key = getCacheKey(params);
    const cached = this.cache.get(key);
    if (cached) {
      return cached;
    }
    const loading = this.loadingPromises.get(key);
    if (loading) {
      return loading;
    }
    const promise = (async () => {
      try {
        const response = await ExchanegeRateService2.getApiV1ExchanegeRateRecommended({
          cryptoCurrencies: params.cryptoCurrencies,
          currencies: params.currencies,
          pageNumber: params.pageNumber,
          pageSize: params.pageSize
        });
        if (!response.data) {
          throw new Error("No data received from recommended rates API");
        }
        this.cache.set(key, response.data);
        return response.data;
      } catch (err) {
        this.error = err instanceof Error ? err : new Error("Failed to load recommended exchange rates");
        throw this.error;
      } finally {
        this.loadingPromises.delete(key);
      }
    })();
    this.loadingPromises.set(key, promise);
    return promise;
  }
};
var recommendedRateStore = new RecommendedRateStore();

// src/entities/exchangeRate/model/types.ts
import {
  ExchangeRateStatusEnum
} from "@acme/api";
var EExchangeRateStatusEnum = { ...ExchangeRateStatusEnum };

// src/entities/exchangeRate/hooks.ts
var useExchangeRate = () => {
  const [exchangeRates, setExchangeRates] = useState5(null);
  const [isLoading, setIsLoading] = useState5(true);
  const [error, setError] = useState5(null);
  const loadExchangeRates = useCallback(async (filter) => {
    try {
      setIsLoading(true);
      const rates = await exchangeRateStore.getExchangeRates(filter);
      setExchangeRates(rates);
      return rates;
    } catch (err) {
      setError(
        err instanceof Error ? err : new Error("Failed to exchange rates")
      );
    } finally {
      setIsLoading(false);
    }
  }, []);
  return { exchangeRates, isLoading, loadExchangeRates, error };
};
var useRecommendedRate = () => {
  const [recommendedRates, setRecommendedRates] = useState5(null);
  const [isLoading, setIsLoading] = useState5(true);
  const [error, setError] = useState5(null);
  const loadRecommendedRates = useCallback(
    async (filter) => {
      try {
        setIsLoading(true);
        const rates = await exchangeRateStore.getRecommendedExchangeRates(filter);
        setRecommendedRates(rates);
        return rates;
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error("Failed to exchange rates")
        );
      } finally {
        setIsLoading(false);
      }
    },
    []
  );
  return { recommendedRates, loadRecommendedRates, isLoading, error };
};

// src/entities/exchangeRate/lib/addWalletAddressesFormConfig.ts
var AddWalletAddressesFormConfig = (includeUnchangedFields = true, wallets, withLabel = false) => {
  const rates = Array.from({ length: wallets }).flatMap(
    (r, idx) => {
      return {
        id: `wallet-${idx}`,
        type: "text",
        ...withLabel && { label: "\u0410\u0434\u0440\u0435\u0441 \u043A\u0440\u0438\u043F\u0442\u043E\u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430" },
        read: (ctx) => ctx?.[`wallet-${idx}`] || "",
        write: { path: `wallet-${idx}` },
        props: {
          placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0438\u043B\u0438 \u0432\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0430\u0434\u0440\u0435\u0441"
        }
      };
    }
  );
  return {
    id: "add-wallet-addresses-form",
    includeUnchangedFields,
    // возвращаем все поля или только измененные
    controls: [...rates]
  };
};

// src/entities/exchangeRate/lib/exchangeRateFormConfig.ts
var exchangeRateFormConfig = (includeUnchangedFields = true, currencyOptions) => ({
  id: "add-currency-form",
  includeUnchangedFields,
  // возвращаем все поля или только измененные
  controls: [
    {
      id: "cryptoCurrency",
      label: "\u0412\u0430\u043B\u044E\u0442\u0430",
      type: "select",
      read: (ctx) => ctx?.cryptoCurrency || "",
      write: { path: "cryptoCurrency" },
      props: {
        placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0430\u043B\u044E\u0442\u0443"
      },
      options: {
        source: currencyOptions
      }
    },
    {
      id: "amount",
      label: "\u041E\u0431\u0449\u0438\u0439 \u043E\u0431\u044A\u0451\u043C \u0432\u0430\u043B\u044E\u0442\u044B",
      type: "number",
      read: (ctx) => ctx?.amount || "",
      write: { path: "amount" },
      props: {
        placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u0431\u044A\u0451\u043C"
      }
    },
    {
      id: "expireAt",
      label: "\u0412\u0440\u0435\u043C\u044F \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043A\u0443\u0440\u0441\u0430",
      type: "datepicker",
      read: (ctx) => ctx?.expireAt || "",
      write: { path: "expireAt" },
      props: {
        placeholder: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u0435\u043D \u0434\u043E:"
      }
    }
  ]
});

// src/entities/net/lib.ts
import { useEffect as useEffect4, useState as useState6 } from "react";

// src/entities/net/model.ts
import {
  DictionariesService as DictionariesService3
} from "@acme/api";
var NetStore = class {
  nets = null;
  loadingPromise = null;
  error = null;
  async getNets() {
    if (this.nets) {
      return this.nets;
    }
    if (this.loadingPromise) {
      return this.loadingPromise;
    }
    this.loadingPromise = (async () => {
      try {
        const response = await DictionariesService3.getApiV1DictionariesNets();
        if (!response?.data?.length) {
          throw new Error("No data received from nets API");
        }
        const nets = response.data.filter(
          (net) => net !== null && net !== void 0
        );
        if (nets.length === 0) {
          throw new Error("No valid nets data received from nets API");
        }
        this.nets = nets;
        return this.nets;
      } catch (err) {
        this.error = err instanceof Error ? err : new Error("Failed to load nets");
        throw this.error;
      } finally {
        this.loadingPromise = null;
      }
    })();
    return this.loadingPromise;
  }
};
var netStore = new NetStore();

// src/entities/net/lib.ts
var useNet = (netId) => {
  const [net, setNet] = useState6();
  const [nets, setNets] = useState6([]);
  const [isLoading, setIsLoading] = useState6(true);
  const [error, setError] = useState6(null);
  useEffect4(() => {
    const loadCountry = async () => {
      try {
        setIsLoading(true);
        const nets2 = await netStore.getNets();
        setNets(nets2);
        if (netId) {
          const foundCountry = nets2.find((c) => c.id === Number(netId));
          setNet(foundCountry);
        }
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error("Failed to load country")
        );
      } finally {
        setIsLoading(false);
      }
    };
    loadCountry();
  }, [netId]);
  return { net, nets, isLoading, error };
};

// src/entities/notification/hooks.ts
import { useEffect as useEffect5, useState as useState7 } from "react";

// src/entities/notification/model.ts
var NotificationsStore = class {
  notifications = [
    {
      id: "1",
      date: /* @__PURE__ */ new Date("2025-09-20T12:35:00"),
      title: "\u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 \u043E\u0442\u0432\u0435\u0442\u0438\u043B \u043D\u0430 \u0432\u0430\u0448\u0435 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0435",
      text: "\u043F\u043E \u0437\u0430\u044F\u0432\u043A\u0435 \u0410\u0411\u0412-123456-789",
      linkText: "#18463361",
      link: "/application/18463361"
    },
    {
      id: "2",
      date: /* @__PURE__ */ new Date("2025-09-20T12:35:00"),
      title: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A\u0430",
      text: "",
      linkText: "",
      link: ""
    },
    {
      id: "3",
      date: /* @__PURE__ */ new Date("2025-09-20T12:35:00"),
      title: "\u0414\u0430\u043D\u043D\u044B\u0435 \u043F\u0440\u043E\u0444\u0438\u043B\u044F \u0431\u044B\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u044B",
      text: "",
      linkText: "",
      link: ""
    }
  ];
  getNotifications() {
    return this.notifications;
  }
  getNotificationById(id) {
    return this.notifications?.find((notification) => notification.id === id);
  }
};
var notificationsStore = new NotificationsStore();

// src/entities/notification/hooks.ts
var useNotification = (notificationId) => {
  const [notification, setNotification] = useState7();
  const [notifications, setNotifications] = useState7([]);
  const [isLoading, setIsLoading] = useState7(true);
  const [error, setError] = useState7(null);
  useEffect5(() => {
    const loadNotifications = async () => {
      try {
        setIsLoading(true);
        const notifications2 = await notificationsStore.getNotifications();
        setNotifications(notifications2);
        if (notificationId) {
          const foundNotification = notifications2.find(
            (n) => n.id === notificationId
          );
          setNotification(foundNotification);
        }
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error("Failed to load notifications")
        );
      } finally {
        setIsLoading(false);
      }
    };
    loadNotifications();
  }, [notificationId]);
  return { notification, notifications, isLoading, error };
};

// src/entities/organization/formConfig.ts
var organizationFormConfig = () => ({
  id: "organization-form",
  controls: [
    {
      id: "organization.name",
      label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435",
      type: "text",
      read: (ctx) => ctx?.name || "",
      write: { path: "name" },
      props: {
        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438"
      }
    },
    {
      id: "organization.inn",
      label: "\u0418\u041D\u041D",
      type: "text",
      read: (ctx) => ctx?.inn || "",
      write: { path: "inn" },
      props: {
        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0418\u041D\u041D \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438"
      }
    },
    {
      id: "organization.ogrn",
      label: "\u041E\u0413\u0420\u041D",
      type: "text",
      read: (ctx) => ctx?.ogrn || "",
      write: { path: "ogrn" },
      props: {
        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u041E\u0413\u0420\u041D"
      }
    },
    {
      id: "organization.legalAddress",
      label: "\u042E\u0440. \u0430\u0434\u0440\u0435\u0441",
      type: "text",
      read: (ctx) => ctx?.legalAddress || "",
      write: { path: "legalAddress" },
      props: {
        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0430\u0434\u0440\u0435\u0441"
      }
    },
    {
      id: "organization.phoneNumber",
      label: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
      type: "text",
      read: (ctx) => ctx?.phoneNumber || "",
      write: { path: "phoneNumber" },
      props: {
        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438"
      }
    },
    {
      id: "organization.bankDetail.accountNumber",
      label: "\u041D\u043E\u043C\u0435\u0440 \u0441\u0447\u0451\u0442\u0430 \u0432 \u0431\u0430\u043D\u043A\u0435",
      type: "text",
      read: (ctx) => ctx?.bankDetail?.accountNumber || "",
      write: { path: "bankDetail.accountNumber" },
      props: {
        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u0441\u0447\u0451\u0442\u0430"
      }
    },
    {
      id: "organization.bankDetail.name",
      label: "\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430",
      type: "text",
      read: (ctx) => ctx?.bankDetail?.name || "",
      write: { path: "bankDetail.name" },
      props: {
        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430"
      }
    },
    {
      id: "organization.bankDetail.identificationCode",
      label: "\u0411\u0418\u041A",
      type: "text",
      read: (ctx) => ctx?.bankDetail?.identificationCode || "",
      write: { path: "bankDetail.identificationCode" },
      props: {
        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0411\u0418\u041A"
      }
    },
    {
      id: "organization.bankDetail.correspondentAccount",
      label: "\u041A\u043E\u0440\u0440. \u0441\u0447\u0451\u0442",
      type: "text",
      read: (ctx) => ctx?.bankDetail?.correspondentAccount || "",
      write: { path: "bankDetail.correspondentAccount" },
      props: {
        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u0441\u043F\u043E\u043D\u0434\u0435\u043D\u0442\u0441\u043A\u0438\u0439 \u0441\u0447\u0451\u0442"
      }
    },
    {
      id: "organization.role",
      label: "\u0420\u043E\u043B\u044C \u043D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0435",
      type: "text",
      read: (ctx) => ctx?.role?.value || "",
      write: { path: "role" },
      props: {
        placeholder: "\u0420\u043E\u043B\u044C",
        disabled: true
      }
    },
    {
      id: "organization.responsiblePersonName",
      label: "\u041E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0435 \u043B\u0438\u0446\u043E",
      type: "text",
      read: (ctx) => ctx?.responsiblePersonName || "",
      write: { path: "responsiblePersonName" },
      props: {
        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0424\u0418\u041E \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0433\u043E \u043B\u0438\u0446\u0430"
      }
    },
    {
      id: "organization.actualAddress",
      label: "\u0424\u0438\u0437. \u0430\u0434\u0440\u0435\u0441",
      type: "text",
      read: (ctx) => ctx?.actualAddress || "",
      write: { path: "actualAddress" },
      props: {
        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0430\u0434\u0440\u0435\u0441"
      }
    }
  ]
});

// src/entities/processTypes/hooks.ts
import { useEffect as useEffect6, useState as useState8 } from "react";

// src/entities/processTypes/model.ts
import {
  DictionariesService as DictionariesService4
} from "@acme/api";
var ProcessTypesStore = class {
  processTypes = null;
  loadingPromise = null;
  error = null;
  async getProcessTypes() {
    if (this.processTypes) {
      return this.processTypes;
    }
    if (this.loadingPromise) {
      return this.loadingPromise;
    }
    this.loadingPromise = (async () => {
      try {
        const response = await DictionariesService4.getApiV1DictionariesProcessTypes();
        if (!response.data) {
          throw new Error("No data received from ProcessTypes API");
        }
        this.processTypes = response.data;
        return this.processTypes;
      } catch (err) {
        this.error = err instanceof Error ? err : new Error("Failed to load ProcessTypes");
        throw this.error;
      } finally {
        this.loadingPromise = null;
      }
    })();
    return this.loadingPromise;
  }
  getProcessTypesById(id) {
    return this.processTypes?.find((doc) => doc.id === id);
  }
  getProcessTypesByCode(code) {
    return this.processTypes?.find((doc) => doc.name === code);
  }
};
var processTypesStore = new ProcessTypesStore();

// src/entities/processTypes/hooks.ts
var useDocType = (docTypeId) => {
  const [docType, setDocType] = useState8();
  const [docTypes, setDocTypes] = useState8([]);
  const [isLoading, setIsLoading] = useState8(true);
  const [error, setError] = useState8(null);
  useEffect6(() => {
    const loadDocTypes = async () => {
      try {
        setIsLoading(true);
        const docTypes2 = await processTypesStore.getProcessTypes();
        setDocTypes(docTypes2);
        if (docTypeId) {
          const foundDocType = docTypes2.find((c) => c.id === docTypeId);
          setDocType(foundDocType);
        }
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error("Failed to load document types")
        );
      } finally {
        setIsLoading(false);
      }
    };
    loadDocTypes();
  }, [docTypeId]);
  return { docType, docTypes, isLoading, error };
};

// src/entities/role/hooks.ts
import {
  DictionariesService as DictionariesService5,
  RoleEnum as RoleEnum2
} from "@acme/api";
import { useEffect as useEffect7, useState as useState9 } from "react";
var useRole = () => {
  const [roles, setRoles] = useState9([]);
  const [isLoading, setIsLoading] = useState9(true);
  const [error, setError] = useState9(null);
  const getRoleByCode = (code) => {
    const codeToRoleMap = {
      ao: RoleEnum2.Admin,
      bk: RoleEnum2.Bank,
      lp: RoleEnum2.Provider,
      ex: RoleEnum2.Client,
      cl: RoleEnum2.Client
    };
    const roleId = codeToRoleMap[code];
    if (!roleId) {
      return void 0;
    }
    return roles.find((r) => r.id === roleId);
  };
  const getRoleById = (id) => {
    return roles.find((r) => r.id === id);
  };
  useEffect7(() => {
    const loadRoles = async () => {
      try {
        setIsLoading(true);
        const response = await DictionariesService5.getApiV1DictionariesRoles();
        if (!response.data) {
          throw new Error("No data received from roles API");
        }
        setRoles(response.data);
      } catch (err) {
        setError(err instanceof Error ? err : new Error("Failed to load role"));
      } finally {
        setIsLoading(false);
      }
    };
    loadRoles();
  }, []);
  return { roles, isLoading, error, getRoleByCode, getRoleById };
};

// src/entities/role/lib/getuserrolename.ts
import { UserRoleEnum } from "@acme/api";
var getUserRoleName = (roleId) => {
  switch (roleId) {
    case UserRoleEnum.Owner:
      return "\u0412\u043B\u0430\u0434\u0435\u043B\u0435\u0446";
    case UserRoleEnum.Employee:
      return "\u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A";
    default:
      return "";
  }
};

// src/entities/role/model/types.ts
var ERoleCode = /* @__PURE__ */ ((ERoleCode2) => {
  ERoleCode2["AO"] = "ao";
  ERoleCode2["BK"] = "bk";
  ERoleCode2["LP"] = "lp";
  ERoleCode2["EX"] = "ex";
  ERoleCode2["CL"] = "cl";
  return ERoleCode2;
})(ERoleCode || {});

// src/entities/role/model/model.ts
import { DictionariesService as DictionariesService6, RoleEnum as RoleEnum3 } from "@acme/api";
var RoleStore = class {
  roles = null;
  loadingPromise = null;
  error = null;
  async getRoles() {
    if (this.roles) {
      return this.roles;
    }
    if (this.loadingPromise) {
      return this.loadingPromise;
    }
    this.loadingPromise = (async () => {
      try {
        const response = await DictionariesService6.getApiV1DictionariesRoles();
        if (!response.data) {
          throw new Error("No data received from roles API");
        }
        this.roles = response.data;
        return this.roles;
      } catch (err) {
        this.error = err instanceof Error ? err : new Error("Failed to load roles");
        throw this.error;
      } finally {
        this.loadingPromise = null;
      }
    })();
    return this.loadingPromise;
  }
  getRoleById(id) {
    return this.roles?.find((role) => role === id);
  }
  getRoleByCode(code) {
    const codeToRoleMap = {
      ao: RoleEnum3.Admin,
      bk: RoleEnum3.Bank,
      lp: RoleEnum3.Provider,
      cl: RoleEnum3.Client
    };
    const roleId = codeToRoleMap[code];
    if (!roleId) {
      return void 0;
    }
    return this.roles?.find((role) => role === roleId);
  }
  clearCache() {
    this.roles = null;
    this.loadingPromise = null;
    this.error = null;
  }
};
var roleStore = new RoleStore();

// src/entities/support/contactCard.tsx
import { CopyableText } from "@acme/foundation";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var ContactCard = ({
  contact,
  rulesLink = "/rules",
  onRulesClick
}) => {
  return /* @__PURE__ */ jsx2("div", { className: "bg-white border border-gray-200 rounded-lg size-full", children: /* @__PURE__ */ jsxs2("div", { className: "flex flex-col gap-6 p-6", children: [
    /* @__PURE__ */ jsx2("div", { className: "flex gap-6 items-start w-full", children: /* @__PURE__ */ jsx2("h2", { className: "font-semibold text-xl text-gray-900", children: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B" }) }),
    /* @__PURE__ */ jsxs2("div", { className: "flex gap-3 items-center pb-3 border-b border-gray-200 w-full", children: [
      /* @__PURE__ */ jsxs2("div", { className: "flex flex-col gap-1 flex-1 min-w-0", children: [
        /* @__PURE__ */ jsx2("p", { className: "text-sm text-gray-500", children: "\u042D\u043B. \u043F\u043E\u0447\u0442\u0430" }),
        /* @__PURE__ */ jsx2(CopyableText, { value: contact.email })
      ] }),
      /* @__PURE__ */ jsxs2("div", { className: "flex flex-col gap-1 flex-1 min-w-0", children: [
        /* @__PURE__ */ jsx2("p", { className: "text-sm text-gray-500", children: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D" }),
        /* @__PURE__ */ jsx2(CopyableText, { value: contact.phone })
      ] }),
      /* @__PURE__ */ jsxs2("div", { className: "flex flex-col gap-1 flex-1 min-w-0", children: [
        /* @__PURE__ */ jsx2("p", { className: "text-sm text-gray-500", children: "\u0420\u0430\u0431\u043E\u0447\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438" }),
        /* @__PURE__ */ jsx2("div", { className: "flex gap-2.5 items-center rounded-lg w-full", children: /* @__PURE__ */ jsx2("p", { className: "font-medium text-base text-gray-900", children: contact.workingHours }) })
      ] })
    ] }),
    onRulesClick ? /* @__PURE__ */ jsx2(
      "button",
      {
        onClick: onRulesClick,
        className: "text-base text-primary-600 hover:text-primary-700 text-left transition-colors",
        children: "\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B"
      }
    ) : /* @__PURE__ */ jsx2(
      "a",
      {
        href: rulesLink,
        className: "text-base text-primary-600 hover:text-primary-700 transition-colors",
        children: "\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B"
      }
    )
  ] }) });
};

// src/entities/support/model.ts
var defaultSupportContact = {
  email: "organization@domain.ru",
  phone: "+7 (987) 654-32-10",
  workingHours: "\u041F\u043D\u2013\u041F\u0442, 10:00\u201318:00 \u041C\u0421\u041A"
};

// src/entities/ticket/generalInfo.tsx
import { FileAttachmentList, formatDateTime as formatDateTime2 } from "@acme/foundation";
import { Link } from "react-router-dom";

// src/entities/ticket/ui/ticketStatusBadge.tsx
import { TicketStatusEnum } from "@acme/api/admin";
import { jsx as jsx3 } from "react/jsx-runtime";
var statusConfig = {
  [TicketStatusEnum.Open]: {
    label: "\u041E\u0436\u0438\u0434\u0430\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0430",
    color: "text-red-800",
    bgColor: "bg-red-100"
  },
  [TicketStatusEnum.InProgress]: {
    label: "\u0412 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435",
    color: "text-yellow-800",
    bgColor: "bg-yellow-100"
  },
  [TicketStatusEnum.Closed]: {
    label: "\u0417\u0430\u043A\u0440\u044B\u0442\u043E",
    color: "text-green-800",
    bgColor: "bg-green-100"
  }
};
var sizeClasses = {
  sm: "px-2.5 py-0.5 text-xs",
  md: "px-3 py-1 text-sm",
  lg: "px-4 py-1.5 text-base"
};
var TicketStatusBadge = ({
  statusId,
  size = "md",
  className = ""
}) => {
  if (!statusId) {
    return null;
  }
  const statusInfo = statusConfig[statusId];
  if (!statusInfo) {
    return null;
  }
  return /* @__PURE__ */ jsx3(
    "span",
    {
      className: `inline-flex items-center rounded-md font-medium ${statusInfo.bgColor} ${statusInfo.color} ${sizeClasses[size]} ${className}`,
      children: statusInfo.label
    }
  );
};

// src/entities/ticket/generalInfo.tsx
import { Fragment, jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var TicketCard = ({
  ticket,
  applicationBasePath,
  onDownloadAttachment,
  dateField = "updateAt"
}) => {
  const dateValue = dateField === "createdAt" ? ticket.createdAt : ticket.updateAt;
  const startMessage = ticket.startMessage;
  return /* @__PURE__ */ jsxs3("div", { className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ jsxs3("div", { className: "flex items-center justify-between gap-4 mb-1", children: [
      /* @__PURE__ */ jsxs3("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ jsxs3("h1", { className: "text-xl font-semibold text-gray-500", children: [
          "#",
          ticket.number
        ] }),
        ticket.applicationCode && (applicationBasePath && ticket.applicationId ? /* @__PURE__ */ jsx4(
          Link,
          {
            to: `${applicationBasePath}/${ticket.applicationId}`,
            className: "text-blue-600 hover:text-blue-700 font-medium",
            children: ticket.applicationCode
          }
        ) : /* @__PURE__ */ jsx4("span", { className: "text-xl font-semibold text-blue-600", children: ticket.applicationCode }))
      ] }),
      /* @__PURE__ */ jsx4("div", { className: "flex items-center gap-3", children: /* @__PURE__ */ jsx4(TicketStatusBadge, { statusId: ticket.status?.id, size: "md" }) })
    ] }),
    ticket.subject && /* @__PURE__ */ jsx4("div", { className: "text-lg mb-3", children: ticket.subject }),
    /* @__PURE__ */ jsxs3("div", { className: "flex justify-between gap-4 mb-6", children: [
      /* @__PURE__ */ jsx4("span", { className: "text-xs text-gray-500", children: formatDateTime2(dateValue) || "\u2014" }),
      ticket.categoryId?.name && /* @__PURE__ */ jsx4("span", { className: "text-sm text-gray-600", children: ticket.categoryId.name })
    ] }),
    startMessage && /* @__PURE__ */ jsxs3(Fragment, { children: [
      startMessage.text && /* @__PURE__ */ jsx4("div", { className: "text-sm text-gray-900", children: startMessage.text }),
      startMessage.attachments && startMessage.attachments.length > 0 && onDownloadAttachment && /* @__PURE__ */ jsx4(
        FileAttachmentList,
        {
          className: "mt-2",
          title: null,
          attachments: startMessage.attachments,
          onDownload: onDownloadAttachment
        }
      )
    ] })
  ] });
};

// src/entities/user/index.ts
import { UserStatusEnum as UserStatusEnum2 } from "@acme/api/client";

// src/entities/user/baseUserStore.ts
var UserStore = class {
  userService;
  user = null;
  organization = null;
  isLoading = false;
  tokenInstaled = false;
  fetchPromise = null;
  constructor(userService) {
    this.userService = userService;
  }
  async fetchUser() {
    if (this.isLoading && this.fetchPromise) {
      return this.fetchPromise;
    }
    this.isLoading = true;
    this.fetchPromise = (async () => {
      try {
        const userData = await this.userService.getUser();
        this.user = userData.data;
        if (this.userService.getOrganization) {
          try {
            const organizationData = await this.userService.getOrganization();
            this.organization = organizationData.data;
          } catch {
            this.organization = null;
          }
        }
      } catch {
        this.user = null;
        this.organization = null;
      } finally {
        this.isLoading = false;
        this.fetchPromise = null;
      }
    })();
    return this.fetchPromise;
  }
  setToken() {
    const tokenString = localStorage.getItem("token");
    const tokenResponse = tokenString ? JSON.parse(tokenString) : null;
    if (tokenResponse?.accessToken) {
      this.userService.setToken?.(tokenResponse.accessToken);
    }
    this.tokenInstaled = true;
  }
  getUser(tokenResponse) {
    if (tokenResponse?.accessToken) {
      this.fetchUser();
    }
  }
  login(tokenResponse) {
    localStorage.setItem("token", JSON.stringify(tokenResponse));
    if (tokenResponse?.accessToken) {
      this.userService.setToken?.(tokenResponse.accessToken);
    }
    this.fetchUser();
  }
  logout() {
    localStorage.removeItem("token");
    this.userService.clearToken?.();
    this.user = null;
    this.organization = null;
  }
  getAuth() {
    const tokenResponse = localStorage.getItem("token");
    return !!tokenResponse;
  }
};

// src/entities/user/lib/personalInfoFormConfig.ts
import { validateRussianSNILS } from "@acme/foundation";
var personalInfoFormConfig = (includeUnchangedFields = true) => ({
  id: "personal-info-form",
  includeUnchangedFields,
  controls: [
    {
      id: "person.name",
      label: "\u0424\u0418\u041E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
      type: "text",
      read: (ctx) => ctx?.person?.name || "",
      write: { path: "person.name" },
      props: {
        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0424\u0418\u041E"
      }
    },
    {
      id: "person.snils",
      label: "\u0421\u041D\u0418\u041B\u0421",
      type: "text",
      read: (ctx) => ctx?.person?.snils || "",
      write: { path: "person.snils" },
      validation: (value) => validateRussianSNILS(typeof value === "string" ? value : ""),
      props: {
        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0421\u041D\u0418\u041B\u0421"
      }
    },
    {
      id: "person.passport.issued",
      label: "\u041A\u0435\u043C \u0432\u044B\u0434\u0430\u043D \u043F\u0430\u0441\u043F\u043E\u0440\u0442",
      type: "text",
      read: (ctx) => ctx?.person?.passport?.issued || "",
      write: { path: "person.passport.issued" },
      props: {
        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u0435\u043C \u0432\u044B\u0434\u0430\u043D \u043F\u0430\u0441\u043F\u043E\u0440\u0442"
      }
    },
    {
      id: "person.title",
      label: "\u0414\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C",
      type: "text",
      read: (ctx) => ctx?.person?.title || "",
      write: { path: "person.title" },
      props: {
        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C"
      }
    },
    {
      id: "person.email",
      label: "\u042D\u043B. \u043F\u043E\u0447\u0442\u0430",
      type: "text",
      read: (ctx) => ctx?.person?.email || "",
      write: { path: "person.email" },
      props: {
        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 email"
      }
    },
    {
      id: "person.phoneNumber",
      label: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
      type: "text",
      read: (ctx) => ctx?.person?.phoneNumber || "",
      write: { path: "person.phoneNumber" },
      props: {
        placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430"
      }
    }
  ]
});

// src/entities/user/lib/useUser.ts
import { useEffect as useEffect8, useState as useState10 } from "react";

// src/entities/user/lib/userStoreContext.tsx
import { createContext, useContext } from "react";
var UserStoreContext = createContext(null);
var useUserStoreContext = () => {
  const store = useContext(UserStoreContext);
  if (!store) {
    throw new Error(
      "useUserStoreContext must be used within UserStoreProvider"
    );
  }
  return store;
};

// src/entities/user/lib/useUser.ts
var useUser = () => {
  const userStore = useUserStoreContext();
  const [user, setUser] = useState10(userStore.user);
  const [organization, setOrganization] = useState10(
    userStore.organization
  );
  const [isLoading, setIsLoading] = useState10(userStore.isLoading);
  const [tokenInstaled, setTokenInstaled] = useState10(
    userStore.tokenInstaled
  );
  useEffect8(() => {
    const interval = setInterval(() => {
      setUser(userStore.user);
      setOrganization(userStore.organization);
      setIsLoading(userStore.isLoading);
      setTokenInstaled(userStore.tokenInstaled);
    }, 200);
    return () => clearInterval(interval);
  }, [userStore]);
  return {
    getAuth: userStore.getAuth.bind(userStore),
    user,
    organization,
    isLoading,
    setToken: userStore.setToken.bind(userStore),
    login: userStore.login.bind(userStore),
    logout: userStore.logout.bind(userStore),
    tokenInstaled,
    fetch: userStore.fetchUser.bind(userStore)
  };
};

// src/entities/user/lib/userStoreProvider.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
var UserStoreProvider = ({
  store,
  children
}) => {
  return /* @__PURE__ */ jsx5(UserStoreContext.Provider, { value: store, children });
};

// src/shared/constants.ts
var API_BASE_URL = "https://api.example.com";
var DEFAULT_PAGE_SIZE = 20;
export {
  API_BASE_URL,
  AccountStatusAlert,
  AddWalletAddressesFormConfig,
  ContactCard,
  DEFAULT_PAGE_SIZE,
  ECurrencyTypeEnum,
  EExchangeRateStatusEnum,
  ERoleCode,
  ErrorHandler,
  TicketCard,
  TicketStatusBadge,
  UserStatusEnum2 as UserStatusEnum,
  UserStore,
  UserStoreContext,
  UserStoreProvider,
  addContractFormConfig,
  applicationOfferFormAddInfoConfig,
  applicationOfferFormMainInfoConfig,
  countryStore,
  createApplicationFormPaymentConfig,
  createapplicationwalletaddressesformconfig,
  currencyFormConfig,
  currencyStore,
  defaultSupportContact,
  exchangeRateFormConfig,
  exchangeRateStore,
  getAuthSecret,
  getAuthSecretAdmin,
  getAuthToken,
  getAuthTokenAdmin,
  getUserRoleName,
  netStore,
  notificationsStore,
  organizationFormConfig,
  personalInfoFormConfig,
  processTypesStore,
  recommendedRateStore,
  roleStore,
  sendOfferFormConfig,
  toCurrency,
  useAuth,
  useCertificates,
  useCountry,
  useCryptoCurrency,
  useCurrency,
  useDocType,
  useExchangeRate,
  useNet,
  useNotification,
  useRecommendedRate,
  useRole,
  useUser,
  useUserStoreContext
};
//# sourceMappingURL=index.js.map